export const twitterShare_URL = 'https://twitter.com/intent/tweet';

export const AUTH_METHODS = {
  EMAIL: 'email',
  FACEBOOK: 'fb'
};

// routes
export const TRACKING_ROUTES = {
    GEO: 'Unavailable Page',
    GAME_OVER: 'Game Over Page',
    WINDOW: 'Closed Page',
    LOGIN: 'Login Page',
    BINGO: 'Bingo Card Page'
};

export const ROUTES = {
  HOME: '/',
  LOGIN: '/auth/login',
  REGISTER: '/auth/register',
};

// API
export const ACTION_TYPES = {
    GET: 'get',
    VOTE: 'vote',
    LOGIN: 'login',
    REGISTER: 'register',
    SWEEPS: 'sweeps',
    SUBMIT: 'submit'
};

// FB
export const FB_ERROR_TYPES = {
    GENERIC: 'fbGeneric',
    PERMISSIONS: 'fbPermissions'
};

// Auth Facebook
export const FACEBOOK_AUTH_TYPES = {
  REAUTHENTICATE: 'reauthenticate',
  REAUTHORIZE: 'reauthorize',
  REREQUEST: 'rerequest'
}

// Auth
export const LOCALSTORAGE = {
    AUTH: '_Auth',
    CARDS: '_Cards',
    SUBMITTED: '_Submitted'
}

// images
export const IMG_LOADING = '/images/loading.svg';

export const VALID_IMAGES = ['jpg', 'jpeg', 'gif', 'png'];
export const VALID_VIDEOS = ['mp4', 'webm', 'ogg'];